<template>
  <!-- TODO: Je to dynamicky, potreba predelat, je to stejny jak bez benefit, ale podle id 3_months.svg -->
  <svg
    height="72"
    viewBox="0 0 80 72"
    width="80"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m79.222 37c0 19.33-15.688 35-35.039 35-10.972 0-20.762-5.036-27.183-12.917a30.492 30.492 0 0 0 7.812 1.011c16.857 0 30.526-13.654 30.526-30.492 0-11.847-6.766-22.122-16.641-27.171a34.526 34.526 0 0 1 5.486-.431c19.35 0 35.04 15.67 35.04 35"
        fill="#4f2b1b"
      />
      <path
        d="m17.62 43v-4.36h-3.44v-23.4h-9.76v4.12h3.76v19.28h-3.76v4.36zm23.6 0v-8.36h-4.32v4h-7.56c.16-1.493.813-2.907 1.96-4.24.747-.853 2.153-2.093 4.22-3.72s3.46-2.933 4.18-3.92c1.013-1.387 1.52-3 1.52-4.84 0-2.187-.727-3.927-2.18-5.22s-3.42-1.94-5.9-1.94c-2.773 0-4.94.767-6.5 2.3s-2.34 3.673-2.34 6.42l.04 1.28h5.16v-.6c0-3.493 1.013-5.24 3.04-5.24 1.733 0 2.6.947 2.6 2.84 0 1.227-.36 2.36-1.08 3.4-.507.747-1.227 1.573-2.16 2.48-1.61 1.58-2.798 2.75-3.563 3.51l-.54.54c-.236.238-.388.394-.457.47-1.28 1.467-2.2 2.96-2.76 4.48s-.84 3.24-.84 5.16l.04 1.2z"
        fill="#ee9f3f"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
